"use strict";
import React from "react";
import $ from "jquery";
import _ from "underscore";
import ApiService from "../services/api_service";
import { EmailWithoutDocuments } from "./email_without_documents";
import { emailService } from "../services/email_service";
import DataStoreService from "./data_store_service";
import { History } from "react-router";
import ToDashboardWithFilters from "./ui/to_dashboard_with_filters";
import { maybePrefetchNextFlowModeItem } from "./flow_mode/flow_mode_service";
function sendEmail(params) {
  return ApiService.addErrorHandler(
    // TODO: use fetch instead
    // eslint-disable-next-line no-restricted-syntax
    $.post("/api/email_messages", params).then(function(r) {
      return DataStoreService.updateStores(r.data);
    }),
    null,
    { caller: "EmailPage.sendEmail" }
  );
}
var EmailPage = React.createClass({
  mixins: [History],
  getInitialState: function() {
    return {
      isLoaded: false
    };
  },
  componentDidMount: function() {
    var id = this.props.params.id;
    emailService.getWithId(id, true).then((email) => {
      var parent = email.parent;
      if (parent) {
        const exceptions = _.some(parent.exceptioned_items, function(item) {
          return item.state !== "complete";
        });
        const exceptionedItem = exceptions[0];
        if (exceptionedItem) {
          if (exceptionedItem.owner_type == "DocumentGroup") {
            $.get("/api/document_groups/" + exceptionedItem.owner_id).then(
              (data) => {
                this.setState({
                  email,
                  parent,
                  documentGroup: data.document_group,
                  isLoaded: true
                });
              }
            );
            return;
          }
        }
      }
      this.setState({
        email,
        parent,
        isLoaded: true
      });
    });
    maybePrefetchNextFlowModeItem(this.props.location);
  },
  setCarrier: function(carrierEvent) {
    return $.post(
      "/api/email_messages/" + this.state.email.id + "/set_carrier",
      {
        carrier_id: carrierEvent.carrierId
      }
    ).then((data) => {
      this.setState({
        email: _.extend(this.state.email, data.email_message)
      });
      return DataStoreService.updateStores(data);
    });
  },
  returningMethods: function() {
    return {
      sendEmail,
      onComplete: this.onComplete
    };
  },
  onComplete: function() {
    ToDashboardWithFilters(this.props.location, this.history);
  },
  render: function() {
    if (this.state.isLoaded) {
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          "data-component": "EmailPage",
          className: "row general-container reply-container"
        },
        /* @__PURE__ */ React.createElement(
          EmailWithoutDocuments,
          {
            documentGroup: this.state.documentGroup,
            email: this.state.email,
            location: this.props.location,
            returningMethods: this.returningMethods(),
            carrierSetter: { onSetCarrier: this.setCarrier }
          }
        )
      );
    } else {
      return /* @__PURE__ */ React.createElement("div", null);
    }
  }
});
export default EmailPage;
